// Display-only formatting of form names.
//
// IMPORTANT: form names are OPERATIONAL identifiers, not just labels. Across the app,
// code matches on them (e.g. instance_name.includes('new student' | 'helper' | ...)),
// derives DOM section IDs from them, stores them as section_name, and enforces a unique
// active-name index. The results of these helpers are for HUMAN DISPLAY ONLY and must
// never be fed back into matching, keys, IDs, section_name, sorting, or persistence.
//
// The school year is currently baked into some form names inconsistently
// ("New Student Form 2025", "Emergency Health Information 2025-2026", others none).
// No app logic reads that year — matchers use year-less substrings — so removing it from
// a label is behavior-safe. A durable fix (structured form_type + real school_year field)
// is planned separately; this helper is the interim, single-source-of-truth display step.

// Matches a trailing school-year token: " 2025" or " 2025-2026" (optional spaces around dash).
const TRAILING_SCHOOL_YEAR = /\s+\d{4}(?:\s*-\s*\d{4})?\s*$/;

// Remove a trailing school-year token from a form name for display.
//   "New Student Form 2025"                       -> "New Student Form"
//   "District - Emergency Health Info 2025-2026"  -> "District - Emergency Health Info"
//   "Chromebook 1:1 Agreement"                    -> unchanged (no trailing 4-digit year)
export function stripFormNameYear(name) {
  if (typeof name !== 'string') return name;
  return name.replace(TRAILING_SCHOOL_YEAR, '').trimEnd();
}

// Audience-aware display name. Admins keep the year (they manage multiple enrollment
// cycles); people-facing views pass { includeYear: false } to hide it.
export function formatFormDisplayName(name, { includeYear = true } = {}) {
  if (typeof name !== 'string') return name;
  return includeYear ? name : stripFormNameYear(name);
}
